import { type SessionCompositionEntry } from "@/shared/domain/sessions";

/** What is known about one file's place in the session. States only, no advice: the add-to-session
 * dialog and the create page offer different follow-up actions, and each renders its own. */
export function sessionCompositionEntryReason(
  entry: SessionCompositionEntry,
): string {
  switch (entry.status) {
    case "included":
      return "Included";
    case "refused":
      return entry.error.message;
    case "notAttempted":
      return "Not sent";
    case "unknown":
      if (entry.observation === "conflict") {
        return "Already in the session with different start and end times.";
      }
      if (entry.observation === "absent") {
        return "Not in the session.";
      }
      if (entry.observation === "unreadable") {
        return "In the session, but its recorded start and end times could not be read.";
      }
      return "Sent, but the session did not confirm whether it was added.";
    default: {
      // Assigning to `never` fails the type check when a status joins SessionCompositionEntry
      // without a case above.
      const unhandled: never = entry;
      return unhandled;
    }
  }
}
